import React, {useLayoutEffect, useRef, useState} from 'react';
import {Box, TableContainer} from '@mui/material';

export default function DualScrollTable({children, label='Défilement horizontal du tableau'}) {
 const top=useRef(null), bottom=useRef(null), [width,setWidth]=useState(0);
 useLayoutEffect(()=>{
  const measure=()=>setWidth((bottom.current?.scrollWidth || 0)+Math.max(0,(top.current?.clientWidth || 0)-(bottom.current?.clientWidth || 0)));
  measure();
  const observer=typeof ResizeObserver==='undefined'?null:new ResizeObserver(measure);
  if(bottom.current){observer?.observe(bottom.current);if(bottom.current.firstElementChild)observer?.observe(bottom.current.firstElementChild);}
  window.addEventListener('resize',measure);
  return()=>{observer?.disconnect();window.removeEventListener('resize',measure);};
 },[children]);
 const sync=(event,target)=>{if(target.current && target.current.scrollLeft!==event.currentTarget.scrollLeft)target.current.scrollLeft=event.currentTarget.scrollLeft;};
 return <Box sx={{minWidth:0}}>
  <Box ref={top} role="region" aria-label={label} tabIndex={0} onScroll={e=>sync(e,bottom)} sx={{overflowX:'auto',overflowY:'hidden',height:20}}><Box sx={{width,height:1}}/></Box>
  <TableContainer ref={bottom} onScroll={e=>sync(e,top)} sx={{maxHeight:'min(55vh, 480px)',overflow:'auto'}}>{children}</TableContainer>
 </Box>;
}
